(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ============================================================================
     TPW Header — SCROLL-LINKED CONTINUOUS CONDENSE (rebuild, 2026-06-25)
     ----------------------------------------------------------------------------
     Replaces the old binary `.header--condensed` class flip + hysteresis dead-band
     + "pin while condensed" hack. Those could never be frame-by-frame smooth: one
     threshold meant every element morphed A→B at once (the visible "jump"), and the
     header was position:sticky so shrinking it changed the in-flow box and shoved
     document scrollY — a feedback loop the dead-band/pin only papered over.

     The new model is a pure CONTINUOUS function of scroll:
       p = clamp(scrollTop / RANGE, 0, 1)          // 0 = full header, 1 = condensed
     `p` is written to --hp on <header.header>. EVERY morph (logo scale, wordmark
     size, eyebrow fade, nav-row collapse, row padding) is a CSS function of --hp,
     so every intermediate scroll value is a valid rendered frame — no class, no
     threshold, no hysteresis. A continuous function cannot flip-flop, so the
     anti-flicker hacks are gone.

     Scroll-coupling is killed structurally: the header is position:fixed and a
     constant-height spacer (= the RESTING full header height) holds the page layout.
     The header never contributes a changing box to flow, so condensing it can never
     move scrollY. (See base.css "TPW Header — fixed shell + spacer".)

     The scroll-up REVEAL / scroll-down HIDE behaviour is preserved cleanly: the
     fixed header translateY's out of view on downward scroll past the morph range
     and back in on upward scroll, driven by the same handler.
     ============================================================================ */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header'); // fixed shell
      this.headerEl = this.header ? this.header.querySelector('.header') : null; // morph target (--hp)
      this.navRow = this.header ? this.header.querySelector('.header-row--medium-nav') : null;
      // sister-store cross-link: fades out via --hp, but like the nav row it must
      // also leave the tab order + click map once it's visually gone (else it's an
      // invisible click target in the condensed bar).
      this.sisterEl = this.header ? this.header.querySelector('.header-sister') : null;
      // account (sign-in) icon: enriched condensed state (2026-06-25) removes it
      // like the sister cell — fades via --hp, then leaves the tab order + click
      // map at the end so it's never an invisible target in the condensed bar.
      // Scope to the MEDIUM main row so we never touch the mobile account.
      this.accountEl = this.header ? this.header.querySelector('.header-row--medium-main .header-account') : null;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';

      // Morph range in px: scroll 0 → RANGE maps p 0 → 1. ~120px gives a calm,
      // deliberate condense without feeling laggy. Tune here only.
      this.RANGE = 120;

      this.p = -1;            // last written progress (so we only touch the DOM on change)
      this.desktop = window.matchMedia('(min-width: 990px)');

      this.ticking = false;
      this.onScrollHandler = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => { this.onScroll(); this.ticking = false; });
      };
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.desktop.addEventListener('change', () => { this.p = -1; this.onScroll(); });

      // Paint the correct frame immediately (e.g. reload mid-page) — no flash of the
      // full header before the first scroll event.
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    getScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    onScroll() {
      if (!this.headerEl) return;
      const scrollTop = this.getScrollTop();

      // --- 1. CONTINUOUS CONDENSE (desktop only) -------------------------------
      // Below 990px the condense is disabled entirely (mobile header untouched):
      // force p=0 so no morph transforms apply.
      let p = 0;
      if (this.desktop.matches) {
        p = scrollTop / this.RANGE;
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
      }
      if (p !== this.p) {
        this.p = p;
        this.headerEl.style.setProperty('--hp', p.toFixed(4));
        // a11y end-state: the nav row collapses to height 0 + opacity 0 via --hp,
        // but its links must also LEAVE the tab order once visually gone. This is
        // the one discrete transition a continuous collapse genuinely needs — set
        // `inert` (with hidden fallback) only at the very end of the morph. Not a
        // band-aid: it's the focus/AT end-state, not a styling threshold.
        if (this.navRow) {
          const gone = p > 0.985;
          if (gone !== this.navGone) {
            this.navGone = gone;
            if ('inert' in HTMLElement.prototype) this.navRow.inert = gone;
            this.navRow.setAttribute('aria-hidden', gone ? 'true' : 'false');
            this.navRow.style.visibility = gone ? 'hidden' : '';
            // sister cell shares the same end-state (faded to opacity 0 by --hp)
            if (this.sisterEl) {
              if ('inert' in HTMLElement.prototype) this.sisterEl.inert = gone;
              this.sisterEl.style.visibility = gone ? 'hidden' : '';
            }
            // account icon shares the SAME end-state (faded to opacity 0 by --hp)
            if (this.accountEl) {
              if ('inert' in HTMLElement.prototype) this.accountEl.inert = gone;
              this.accountEl.style.visibility = gone ? 'hidden' : '';
            }
          }
        }
      }

      // --- 2. ALWAYS-PINNED (founder 2026-06-26) -------------------------------
      // The header is ALWAYS pinned: the condensed second state stays put at every
      // scroll depth. There is no hide-on-scroll-down — the old direction-based
      // reveal/hide slid it off-screen, which read as the condensed bar
      // "completely vanishing." So onScroll only drives the morph (section 1).
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
